<template>
  <div class="component-container">
    <div class="form-container">
      <div class="row">
        <div class="col-label">
          {{ $t('updatePasswordForm.LABEL_OLD_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input
            v-model="oldPassword"
            type="password"
            show-password
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          {{ $t('updatePasswordForm.LABEL_NEW_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input
            v-model="newPassword"
            type="password"
            show-password
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          {{ $t('updatePasswordForm.LABEL_CONFIRM_NEW_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input
            v-model="confirmNewPassword"
            type="password"
            show-password
          ></el-input>
        </div>
      </div>
      <div class="btn-container row">
        <el-button
          type="primary"
          @click="confirm"
          :disabled="confirmBtnDisabled"
        >
          <span class="yahei">{{ $t('updatePasswordForm.BTN_CONFIRM') }}</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import UserModel from '../../models/user'
import * as storage from '../../utils/storage'
import * as constants from '../../constants'

export default {
  name: 'Updatepassword',
  components: {},
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      teamname: '',
      token: '',
      userName: '',
    }
  },
  methods: {
    async confirm() {
      try {
        const passwordInfo = this._validate()
        const data = await UserModel.passwordChange(passwordInfo)
        if (data && data.errNo === 0) {
          let msg = this.$t('updatePasswordForm.TIPS_SUCCESS')
          let title = this.$t('updatePasswordForm.TIPS_TITLE_SUCCESS')
          let ok = this.$t('page.SUBMIT_CONFIRM_OK')
          let type = 'success'
          this.$msgbox({
            title: title,
            message: msg,
            showCancelButton: true,
            confirmButtonText: ok,
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: type,
          }).then(async () => {
            await UserModel.logout()
            const info = storage.getItem(constants.WX_INFO)
            const router = this.$router
            if (info) {
              storage.setItem(constants.GLOBAL_CONFIG, null)
              router.push(`/wxlogin.html`)
            } else {
              let logo = storage.getItem(constants.LOGO)
              storage.clear()
              if (logo !== -1) {
                storage.setItem(constants.LOGO, logo)
              }
              window.location.href = '/login.html'
            }
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    _validate() {
      const oldPassword = this.oldPassword.trim()
      const newPassword = this.newPassword.trim()
      const confirmNewPassword = this.confirmNewPassword.trim()

      if (newPassword !== confirmNewPassword) {
        throw new Error(this.$t('jtRegisterForm.PASSWORD_CONFIRM_DIRTY'))
      }
      return { oldPassword, newPassword }
    },
  },

  computed: {
    confirmBtnDisabled() {
      return _.isEmpty(this.newPassword) || _.isEmpty(this.confirmNewPassword)
    },
  },

  created() {},
}
</script>

<style lang="stylus" scoped>
.form-container {
  width: 100%;
  max-width: 600px;
  margin: 100px auto 0;
  padding: 10px;

  .row {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;

    .col-label {
      font-size: 16px;
      margin-right: 15px;
      margin-top: 10px;
      width: 150px;
    }

    .col-content {
      width: 100%;
    }

    button {
      min-width: 100px;
      font-size: 16px;
    }
  }
}
</style>
